import { render } from "./usertotalList.vue?vue&type=template&id=540910f3&scoped=true"
import script from "./usertotalList.vue?vue&type=script&lang=js"
export * from "./usertotalList.vue?vue&type=script&lang=js"

import "./usertotalList.vue?vue&type=style&index=0&id=540910f3&scoped=true&lang=css"

import exportComponent from "/Users/cole/.codex/worktrees/jwt-cookie-expiry/tcd-cube_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-540910f3"]])

export default __exports__